import { Flex } from 'components/Flex';
import { SectionDivider } from 'modals/ShiftModal/ShiftModal.styled';
import {
  LabelText,
  ReviewCommunityName,
  CommentText,
} from 'modals/JaneDetailsModal/views/JaneDetailsView/ReviewsTab/ReviewsTab.styled';
import { JaneAvatarWrapper } from 'modals/JaneDetailsModal/views/EditJaneView/EditJaneView.styled';
import { JaneAvatar } from 'components/BKJJaneAvatar';
import { humanReadableDate } from 'modals/JaneDetailsModal/JaneDetailsModal.constants';
import { Review } from 'types/graphql';
import { StarRating } from 'components/StarRating';
import { useSelector } from 'react-redux';
import isUserTimeFormat24hSelector from 'store/selectors/userSelectors/isUserTimeFormat24hSelector';

export const ReviewCommentCard = ({ review }: { review: Review }) => {
  const isUserTimeFormat24h = useSelector(isUserTimeFormat24hSelector);
  return (
    <Flex flexDirection="column" gap="16px">
      <Flex justifyContent="space-between" alignItems="center">
        <Flex gap="10px" alignItems="center" padding="0 0 0 6px">
          <JaneAvatarWrapper>
            <JaneAvatar
              url={review?.reviewer?.avatarUrls?.small}
              status={'accepted'}
              size={35}
              pendingSignup={false}
            />
          </JaneAvatarWrapper>
          <Flex flexDirection="column" gap="8px">
            <LabelText>
              {review?.reviewer?.firstName} {review?.reviewer?.lastName}
            </LabelText>
            <ReviewCommunityName>{review?.order?.community?.name}</ReviewCommunityName>
          </Flex>
        </Flex>
        <ReviewCommunityName>
          {humanReadableDate(review?.createdAt, undefined, isUserTimeFormat24h)}
        </ReviewCommunityName>
      </Flex>
      {review?.comment && <CommentText>{review?.comment}</CommentText>}
      <Flex gap="15px" padding="0 0 0 6px">
        <StarRating rating={review?.rating || 0} />
      </Flex>
      <SectionDivider variant="Thin" />
    </Flex>
  );
};
